import { downloadText } from "./download";

export type CSVCell = string | number | boolean | null | undefined;
export type CSVRow = CSVCell[];

type DownloadCSVParams = {
  filename: string;
  headers: CSVRow;
  rows: CSVRow[];
};

function escapeCSVValue(value: CSVCell): string {
  const str = String(value ?? "").replace(/"/g, '""');
  return `"${str}"`;
}

function buildCSV(headers: CSVRow, rows: CSVRow[]): string {
  return [headers, ...rows]
    .map((row) => row.map(escapeCSVValue).join(","))
    .join("\r\n");
}

export function downloadCSVFile({
  filename,
  headers,
  rows,
}: DownloadCSVParams) {
  const csv = buildCSV(headers, rows);
  downloadText(csv, filename, "text/csv;charset=utf-8;");
}
